'use strict';
import * as $j_app$002edata$002e$002dDrug$002dDescription$0024 from "./app.data.-Drug-Description$.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$60() {
}
export { $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$60 as $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$60 };
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$60.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$60.prototype.constructor = $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$60;
/** @constructor */
function $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$60() {
}
export { $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$60 as $h_Lapp_api_DrugRequestsAcceptedListItem$$anon$60 };
$h_Lapp_api_DrugRequestsAcceptedListItem$$anon$60.prototype = $c_Lapp_api_DrugRequestsAcceptedListItem$$anon$60.prototype;
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$60.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_api_DrugRequestsAcceptedListItem$$anon$60.prototype.apply__O = (function() {
  return $j_app$002edata$002e$002dDrug$002dDescription$0024.$m_Lapp_data_DrugDescription$().derived$Schema__Lsttp_tapir_Schema();
});
var $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$60 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_DrugRequestsAcceptedListItem$$anon$60, "app.api.DrugRequestsAcceptedListItem$$anon$60", ({
  Lapp_api_DrugRequestsAcceptedListItem$$anon$60: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$60 as $d_Lapp_api_DrugRequestsAcceptedListItem$$anon$60 };
//# sourceMappingURL=app.api.-Drug-Requests-Accepted-List-Item$$anon$60.js.map
